module.exports = __webpack_public_path__ + "static/media/fa-solid-900.c81f3983.woff";